import type { NavigationGuardNext, Router } from 'vue-router'
import { useAppStore } from '@/stores/portal-stores/general-stores/app'
import { useNavigationStore } from '@/stores/portal-stores/component-stores/navigation'
import { useTrackingStore } from '@/stores/portal-stores/general-stores/tracking'
import { useFileStore } from '../stores'
import { getWebAppUrl } from '@/application/helpers/urlHelper'

export function setupBeforeEach(router: Router) {
  router.beforeEach(async (to, from, next: NavigationGuardNext) => {
    const appStore = useAppStore()
    const tracking = useTrackingStore()
    const fileStore = useFileStore()
    const navigationStore = useNavigationStore()

    tracking.trackEvent('page_view', {
      page_location: getWebAppUrl() + to.fullPath,
      page_title: appStore.content !== undefined ? appStore.content.type : ''
    })

    const navigationOptions = navigationStore.navigationOptions(from.fullPath)
    if (
      navigationOptions.navItem?.type === 'documentssection' ||
      navigationOptions.navItem?.type === 'assignmentsection'
    ) {
      if (fileStore.selectedFiles.length > 0) {
        const answer = window.confirm(
          'You are about to leave ' +
            navigationOptions.navItem?.type +
            '\n' +
            'While you have a pending upload ' +
            '\n' +
            'Are you sure you wish to leave?'
        )
        if (answer === true) {
          fileStore.setSelectedFiles([])
          return next()
        } else {
          return next(false)
        }
      } else {
        next()
      }
    }

    next()
  })
}
